import * as _ from 'lodash-es'
import { useContext, useRef } from 'react'
import { GameContext } from '../GameContextF.jsx'
import { ThreeColPill } from '../common/PlayersList/ThreeColPill.jsx'
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { useNow } from '../../../componentsF/hooksF/useNowF.jsx'
import { durHumanAbs } from '../../../sharedF/langF/dur2HumanF.mts'
import { gameStateMsToLux } from '../../sharedF/gameStateMsToLuxAI.mjs'
import { HStack, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, useDisclosure } from '@chakra-ui/react'

const taskVerbs = {
  InitialPrompt:   'thinking',
  DrawDescription: 'drawing',
  DescribeDrawing: 'describing',
  WaitingTask:     'waiting',
}

const PlayerPubState = (publicState) => {
  const {now} = useNow()
  const {playerAlias, myTaskName, gameActiveAt} = gameStateMsToLux(publicState)
  const {isHost} = useContext(GameContext)
  let { isOpen, onClose, onOpen } = useDisclosure()
  if (!isHost) {
    isOpen = false
  }
  const initialFocusRef = useRef(/** @type {HTMLElement | null} */ (null))

  const rightContent = <Ptext {...{fontSize: 'md', userSelect: 'none'}}>
    {taskVerbs[myTaskName]}
    &nbsp;
    {gameActiveAt && durHumanAbs(gameActiveAt.diff(now))}
  </Ptext>

  return <ThreeColPill key={playerAlias} {...{my: 4, rightContent}} >
    <Popover {...{isOpen, onClose, initialFocusRef}}>
      <PopoverTrigger>
        <Ptext {...{onClick: onOpen, userSelect: 'none'}}>
          {playerAlias}
        </Ptext>
      </PopoverTrigger>
      <PopoverContent {...{w: {base: 'sm', sm: 'md'}}}>
        <PopoverArrow />
        <PopoverBody {...{as: HStack}}>
          {/* <SendGameMsg {...{gpToPlayerName: playerAlias, onClose, initialFocusRef}} /> */}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  </ThreeColPill>
}

export const PlayerStatuses = () => {
  const {publicStates} = useContext(GameContext)

  return <div data-testid="player-statuses">{_.map(publicStates, (publicState) => <PlayerPubState key={publicState.playerAlias} {...publicState} />)}</div>
}